export class FirebaseRefListener {
  ref: any
  event: string
  listener: any

  constructor (ref: any, event: string, listener: any) {
    this.ref = ref
    this.event = event
    this.listener = listener
  }
}

export enum FirebaseEvents {
  CHILD_ADDED = 'child_added',
  CHILD_CHANGED = 'child_changed',
  VALUE = 'value'
}
